export class SellerModel {
  sellerId: number = 0;
  branchId: number = 0;
  typeDocumentId: number = 0;
  document: string = '';
  digitVerification: number = 0;
  alterCode: string | null = null;
  name: string = '';
  position: string = '';
  active: boolean = true;
  swExternal: boolean = false;
  phone: string | null = null;
  alterPhone: string | null = null;
  email: string | null = null;
  address: string | null = null;
  departmentId: number = 0;
  cityId: number = 0;
  observation: string | null = null;
  userId: number | null = null;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
